import React from 'react';
import CopyableSnippet from '../../components/utils/CopyableSnippet';

const Visibility = () => (
  <React.Fragment>
    <div className="page-header">
      <p>Core</p>
      <h1>Visibility</h1>
    </div>
    <div className="page-content">
      <div className="component-example__sub-example">
        <p>
          To make an element visible use class
          <CopyableSnippet code="visible" />
          To hide it use class
          <CopyableSnippet code="hidden" />
        </p>
        <p>
          For responsive visibility use classes
          <CopyableSnippet code="visible-(screen)" />
          and
          <CopyableSnippet code="hidden-(screen)" />
        </p>
        <p>
          The (screen) values are
          <CopyableSnippet code="xs" />
          <CopyableSnippet code="sm" />
          <CopyableSnippet code="md" />
          <CopyableSnippet code="lg" />
        </p>
        <p className="margin-bottom-lg">Examples:</p>
        <p className="tds-panel component-example__grey-bg padding-lg visible-lg">
          <CopyableSnippet code="visible-lg" />
        </p>
        <p className="tds-panel component-example__grey-bg padding-lg visible-md">
          <CopyableSnippet code="visible-md" />
        </p>
        <p className="tds-panel component-example__grey-bg padding-lg visible-sm">
          <CopyableSnippet code="visible-sm" />
        </p>
        <p className="tds-panel component-example__grey-bg padding-lg visible-xs">
          <CopyableSnippet code="visible-xs" />
        </p>
        <p className="tds-panel component-example__grey-bg padding-lg hidden-lg">
          <CopyableSnippet code="hidden-lg" />
        </p>
        <p className="tds-panel component-example__grey-bg padding-lg hidden-md">
          <CopyableSnippet code="hidden-md" />
        </p>
        <p className="tds-panel component-example__grey-bg padding-lg hidden-sm">
          <CopyableSnippet code="hidden-sm" />
        </p>
        <p className="tds-panel component-example__grey-bg padding-lg hidden-xs">
          <CopyableSnippet code="hidden-xs" />
        </p>
      </div>
    </div>
  </React.Fragment>
);

export default Visibility;
